// @flow
import { intersect } from '@tectonics/commons/arrays';
import { getSafeFeatureByName, getSupportedTraits, type Feature, type FeatureName } from '@tectonics/prs/feature';
import { getSafeSupportedFeatureByName } from '@tectonics/prs/support';
import { type LookAndFeel } from './types';

export function getImplementedTraits(
  lookAndFeel: LookAndFeel,
  featureName: FeatureName,
  allFeatures: ImmutableArray<Feature>,
): ImmutableArray<string> {
  const specFeature = getSafeFeatureByName(allFeatures, featureName);
  const specTraits = getSupportedTraits(specFeature);

  const supportFeature = getSafeSupportedFeatureByName(featureName, lookAndFeel.prsSupport);
  const supportTraits = getSupportedTraits(supportFeature);

  return intersect(specTraits, supportTraits);
}
